<form class="register-form" [formGroup]="registerForm" (ngSubmit)="onRegister()">
  <label class="f-label">Organization name* </label>
  <mat-form-field class="input-field" appearance="outline">
    <mat-icon matSuffix>business</mat-icon>
    <input type="text" matInput placeholder="Your company or organization name" formControlName="name" required>
    <mat-error *ngIf="registerForm.get('name')?.hasError('required')">Organization name is required</mat-error>
    <mat-error *ngIf="registerForm.get('name')?.hasError('minlengthStrict')">Minimum 2 characters</mat-error>
    <mat-error *ngIf="registerForm.get('name')?.hasError('digitsOnly')">Cannot be only numbers</mat-error>
    <mat-error *ngIf="registerForm.get('name')?.hasError('alphaRequired')">Must include letters</mat-error>
    <mat-error *ngIf="registerForm.get('name')?.hasError('multiSpace')">No consecutive spaces</mat-error>
    <mat-error *ngIf="registerForm.get('name')?.hasError('invalidChars')">Only letters, numbers and . , & - ' (
      )</mat-error>
    <mat-error *ngIf="registerForm.get('name')?.hasError('whitespace')">Cannot be empty or only spaces</mat-error>
  </mat-form-field>
  <label class="f-label">Email* <i>(Only business email id)</i></label>
  <mat-form-field class="input-field" appearance="outline">
    <mat-icon matSuffix>email</mat-icon>
    <input type="email" matInput placeholder="your@company.com" formControlName="email" required>
  </mat-form-field>
  <label class="f-label">Password*
    <mat-icon class="timer-icon" matTooltip="{{passwordConditions}}"
      matTooltipClass="custom-tooltip">info_outline</mat-icon>
  </label>
  <mat-form-field class="input-field" appearance="outline">
    <input [type]="showPassword ? 'text' : 'password'" matInput placeholder="Create a secure password"
      formControlName="password" required>
    <mat-icon matSuffix (click)="$event.stopPropagation(); showPassword = !showPassword">{{showPassword ? 'visibility' :
      'visibility_off'}} </mat-icon>
  </mat-form-field>
  <label class="f-label">Address*</label>
  <mat-form-field class="input-field address-field" appearance="outline">
    <textarea type="address" rows="3" matInput placeholder="Your company address" formControlName="address"
      required></textarea>
    <mat-error *ngIf="registerForm.get('address')?.hasError('required')">Address is required</mat-error>
    <mat-error *ngIf="registerForm.get('address')?.hasError('minlengthStrict')">Address must be at least 5
      characters</mat-error>
    <mat-error *ngIf="registerForm.get('address')?.hasError('maxlength')">Address must be at most 200
      characters</mat-error>
    <mat-error *ngIf="registerForm.get('address')?.hasError('digitsOnly')">Address cannot be only numbers</mat-error>
    <mat-error *ngIf="registerForm.get('address')?.hasError('whitespace')">Address cannot be empty or only
      spaces</mat-error>
    <mat-error *ngIf="registerForm.get('address')?.hasError('invalidChars')">Only letters, numbers, spaces, new lines
      and . , # - '
      / ( ) ; are allowed</mat-error>
  </mat-form-field>
  <div class="submit-section">
    <button mat-flat-button color="primary" type="submit" [disabled]="!registerForm.valid" class="signup-btn-txt">Sign
      Up</button>
    <a mat-button href="javascript:void(0)" class="register-btn-txt" (click)="gotoLogin()">Go to login</a>
  </div>
</form>